import { render } from "./TableComponent.vue?vue&type=template&id=b328ecc8"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__